export default __webpack_public_path__ + "static/media/Background_00005.82e3c874.png";